import Requester from '../../helpers/requester';
import { HTTP_METHODS } from '../../helpers/constants';
import { API_PATHS } from '../../helpers/endpoints';
import { deleteZoneSlotTemplates } from '../requests/slot';

export default {
  addSlotTemplate: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.SLOT_TEMPLATES}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getSlotTemplatesById: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.SLOT_TEMPLATES_BY_ID}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getSlotTemplates: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.SLOT_TEMPLATES_SEARCH}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteSlotTemplates: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.SLOT_TEMPLATES}/delete`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  changeStatusSlotTemplates: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.SLOT_TEMPLATES}/change/status`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  editSlotTemplate: async (data, id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.SLOT_TEMPLATES}/${id}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getZoneSlotTemplates: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.ZONE_SLOT_TEMPLATES}/filter`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  createZoneSlotTemplates: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.ZONE_SLOT_TEMPLATES}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getSlotZone: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.SLOT_ZONE}/zone/${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getSlots: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.SLOT_ZONE}/search${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getZonesByStoreIdForSlots: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ZONES_SEARCH_V2}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  importFileZoneSlotTemplate: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.DATA_IMPORT}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getSlotsByZoneIdForTwoDays: async (zoneId, date) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.SLOTS_OF_ZONE}/${zoneId}?deliveryDays=2&fromDate=${date}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  editSlot: async (data, id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.SLOTS}/${id}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addSlot: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.SLOTS}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteSlot: async (id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.DELETE,
        url: `${API_PATHS.SLOTS}/${id}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getDownloadLinkSlotCapacity: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.DATA_TEMPLATE}/SlotCapacityUpdate`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  changeStatusZoneSlotTemplates: async (payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.ZONE_SLOT_TEMPLATES}/change/status`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteZoneSlotTemplates: async (payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.ZONE_SLOT_TEMPLATES}/delete`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  generateSlotForZone: async (zoneId, slotId) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PATCH,
        url: `${API_PATHS.SLOTS_OF_ZONE}/${zoneId}/template/${slotId}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};
